import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { REGISTER } from "@/constants/testIds";

export function RegisterForm({ name, email, password, confirmPassword, loading, onChange, onSubmit }) {
  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div>
        <Label htmlFor="name" className="text-zinc-500 text-xs uppercase tracking-wide">Name</Label>
        <Input
          id="name" required value={name} onChange={(e) => onChange("name", e.target.value)}
          data-testid={REGISTER.nameInput}
          className="bg-white border-zinc-300 text-zinc-950 focus:border-zinc-950 focus:ring-1 focus:ring-[#4FD1C5] rounded-none mt-1"
        />
      </div>
      <div>
        <Label htmlFor="email" className="text-zinc-500 text-xs uppercase tracking-wide">Email</Label>
        <Input
          id="email" type="email" required value={email} onChange={(e) => onChange("email", e.target.value)}
          data-testid={REGISTER.emailInput}
          className="bg-white border-zinc-300 text-zinc-950 focus:border-zinc-950 focus:ring-1 focus:ring-[#4FD1C5] rounded-none mt-1"
        />
      </div>
      <div>
        <Label htmlFor="password" className="text-zinc-500 text-xs uppercase tracking-wide">Password</Label>
        <Input
          id="password" type="password" required minLength={6} value={password} onChange={(e) => onChange("password", e.target.value)}
          data-testid={REGISTER.passwordInput}
          className="bg-white border-zinc-300 text-zinc-950 focus:border-zinc-950 focus:ring-1 focus:ring-[#4FD1C5] rounded-none mt-1"
        />
      </div>
      <div>
        <Label htmlFor="confirmPassword" className="text-zinc-500 text-xs uppercase tracking-wide">Confirm Password</Label>
        <Input
          id="confirmPassword" type="password" required minLength={6} value={confirmPassword} onChange={(e) => onChange("confirmPassword", e.target.value)}
          data-testid={REGISTER.passwordConfirmInput}
          className="bg-white border-zinc-300 text-zinc-950 focus:border-zinc-950 focus:ring-1 focus:ring-[#4FD1C5] rounded-none mt-1"
        />
      </div>
      <p className="text-xs text-zinc-500">
        By signing up, you agree to receive updates from BBAP. See our{" "}
        <Link to="/privacy" className="underline hover:text-zinc-950">Privacy Policy</Link>.
      </p>
      <Button type="submit" disabled={loading} data-testid={REGISTER.submitButton} className="w-full bg-zinc-950 text-white font-medium rounded-none hover:bg-zinc-900 hover:shadow-[0px_4px_0px_0px_#4FD1C5]">
        {loading ? "Creating account..." : "Sign Up"}
      </Button>
    </form>
  );
}
